import { isAccountPlanValid } from './validateSelectedPlan';

export const getQuizProgressAccessKey = (selectedPlan) => {
  if (!isAccountPlanValid(selectedPlan)) return null;
  return `${selectedPlan.toLowerCase()}QuizProgress`;
};
